import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import locale from "antd/es/date-picker/locale/ru_RU";
import "dayjs/locale/ru";

const { RangePicker } = DatePicker;

interface DateRangePickerProps {
  onChange: (dates: [string, string] | null) => void;
  className?: string;
  noDefaultValues?: boolean;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  onChange,
  className,
  noDefaultValues = false,
}) => {
  const today = dayjs();

  const [selectedDates, setSelectedDates] = useState<[Dayjs, Dayjs]>(
    !noDefaultValues && [today, today],
  );

  const handleChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (dates && dates[0] && dates[1]) {
      setSelectedDates([dates[0], dates[1]]);
      onChange([dates[0].format("YYYY-MM-DD"), dates[1].format("YYYY-MM-DD")]);
    } else {
      setSelectedDates([today, today]);
      onChange(null);
    }
  };

  useEffect(() => {
    const defaultDate = today.format("YYYY-MM-DD");
    onChange([defaultDate, defaultDate]);
  }, []);

  return (
    <RangePicker
      locale={locale}
      value={selectedDates}
      onChange={handleChange}
      format="DD.MM.YYYY"
      allowClear={false}
      className={className}
    />
  );
};
